import { sequence } from 'iguazu';
import { queryProcedureResult } from 'iguazu-rpc';
import { queryProductsRegistry } from 'axp-product-ducks';
import { getPublicGuid, getAccountToken } from '../selectors';
import { makeReadMemberPreferencesArgs } from '../utils';
import { TYPE_CREDO_OPT_IN } from '../constants';
const queryCredoPreferences = function () {
  let {
    store: {
      dispatch,
      getState
    } = {},
    types = [TYPE_CREDO_OPT_IN],
    timeout,
    fallbackValue = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const fallback = types.map(type => ({
    type,
    value: fallbackValue
  }));
  try {
    const {
      memberPreferences
    } = sequence([{
      key: 'registryData',
      handler: () => dispatch(queryProductsRegistry())
    }, {
      key: 'memberPreferences',
      handler: () => {
        const state = getState();
        const publicGuid = getPublicGuid(state);
        const accountToken = getAccountToken(state);
        const memberPreferencesResponse = dispatch(queryProcedureResult({
          procedureName: 'readMemberPreferencesV1',
          args: makeReadMemberPreferencesArgs({
            publicGuid,
            accountToken,
            types,
            timeout
          })
        }));
        const {
          data,
          promise: memberPreferencesPromise,
          error,
          ...rest
        } = memberPreferencesResponse;
        return {
          data: error ? fallback : data,
          promise: memberPreferencesPromise.then(res => res instanceof Error ? fallback : res),
          error,
          ...rest
        };
      }
    }]);
    const {
      data,
      status,
      error,
      promise
    } = memberPreferences();
    return {
      data,
      status,
      error,
      promise: promise.then(_ref => {
        let {
          memberPreferences: credo
        } = _ref;
        return credo;
      })
    };
  } catch (err) {
    return {
      status: 'complete',
      data: fallback,
      promise: Promise.resolve(fallback)
    };
  }
};
export default queryCredoPreferences;